(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hf-collapsible-script"] && !Shopify.designMode) return;
  try {
    if (!window.__hfCollapsibleInit) {
    window.__hfCollapsibleInit = true;

    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('.hf-collapsible-toggle');
      if (!toggle) return;

      const controlsId = toggle.getAttribute('aria-controls');
      let target = controlsId ? document.getElementById(controlsId) : null;

      if (!target) {
        const parent = toggle.parentElement;
        if (parent) target = parent.nextElementSibling;
      }

      if (!target || !target.classList.contains('hf-collapsible')) return;

      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      target.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hf-video-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hf-video-controls')) {
    class HfVideoControls extends HTMLElement {
      constructor() {
        super();
        this._observer = null;
        this._slideObserver = null;
        this._visible = false;
        this._playing = false;
        this._muted = true;
        this._inSlider = false;
        this._initRAF = null;
        this._bound = false;
        this._hideTimer = null;

        this._onTogglePlay = this._togglePlay.bind(this);
        this._onToggleMute = this._toggleMute.bind(this);
        this._onMessage = this._handleIframeMessage.bind(this);
        this._onVideoPlaying = () => this._setPlaying(true);
        this._onVideoPause = () => this._setPlaying(false);
        this._onVideoEnded = () => { if (!this._loop) this._setPlaying(false); };
        this._onTouch = this._handleTouch.bind(this);
        this._onSurfaceClick = this._handleSurfaceClick.bind(this);
      }

      connectedCallback() {
        if (this._pendingDisconnect != null) {
          clearTimeout(this._pendingDisconnect);
          this._pendingDisconnect = null;
          return;
        }
        const runInit = () => {
          this._initIdle = null;
          this._initTimer = null;
          if (!this.isConnected || this._initialized) return;
          this._initialized = true;
          this._fullInit();
        };
        if (typeof requestIdleCallback === 'function') {
          this._initIdle = requestIdleCallback(runInit, { timeout: 1500 });
        } else {
          this._initTimer = setTimeout(runInit, 0);
        }
      }

      _fullInit() {
        const videos = this.querySelectorAll('video');
        const iframes = this.querySelectorAll('iframe[data-video-type]');
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const activeVariant = isMobile ? 'mobile' : 'desktop';

        const pickActive = (els) => {
          if (els.length <= 1) return { active: els[0] || null, inactive: [] };
          let active = null;
          const inactive = [];
          els.forEach((el) => {
            const container = el.closest('[data-video-variant]');
            if (container && container.dataset.videoVariant === activeVariant) active = el;
            else inactive.push(el);
          });
          if (!active) {
            active = els[0];
            inactive.length = 0;
            for (let i = 1; i < els.length; i++) inactive.push(els[i]);
          }
          return { active: active, inactive: inactive };
        };

        const deactivate = (el) => {
          if (el.tagName === 'VIDEO') {
            el.removeAttribute('autoplay');
            try { el.pause(); } catch (_) {}
            el.querySelectorAll('source').forEach((s) => {
              s.removeAttribute('src');
              s.removeAttribute('data-src');
            });
            el.removeAttribute('src');
            try { el.load(); } catch (_) {}
          } else if (el.tagName === 'IFRAME') {
            el.removeAttribute('src');
            el.removeAttribute('data-src');
          }
        };

        const videoPick = pickActive(videos);
        const iframePick = pickActive(iframes);
        videoPick.inactive.forEach(deactivate);
        iframePick.inactive.forEach(deactivate);

        this._video = videoPick.active;
        this._iframe = iframePick.active;
        this._playBtn = this.querySelector('.hf-video-controls__btn--play');
        this._muteBtn = this.querySelector('.hf-video-controls__btn--mute');

        this._autoplay = this.dataset.autoplay === 'true';
        this._loop = this.dataset.loop === 'true';
        this._muted = true;

        if (!this._bound) {
          this._bound = true;
          if (this._playBtn) this._playBtn.addEventListener('click', this._onTogglePlay);
          if (this._muteBtn) this._muteBtn.addEventListener('click', this._onToggleMute);
        }

        if (this._video || this._iframe) {
          this._surface = this.querySelector(':scope > .hf-video-controls__surface');
          if (!this._surface) {
            this._surface = document.createElement('div');
            this._surface.className = 'hf-video-controls__surface';
            this._surface.setAttribute('aria-hidden', 'true');
            this.insertBefore(this._surface, this.firstChild);
          }
          this._surface.addEventListener('touchstart', this._onTouch, { passive: true });
          this._surface.addEventListener('click', this._onSurfaceClick);
        }

        if (this._video) {
          this._video.muted = true;
          this._video.playsInline = true;
          this._video.addEventListener('playing', this._onVideoPlaying);
          this._video.addEventListener('pause', this._onVideoPause);
          this._video.addEventListener('ended', this._onVideoEnded);
        }

        if (this._iframe) {
          window.addEventListener('message', this._onMessage);
        }

        this._setupObservers();
      }

      disconnectedCallback() {
        this._pendingDisconnect = setTimeout(() => {
          this._pendingDisconnect = null;
          this._cleanup();
        }, 250);
      }

      _cleanup() {
        if (this._initIdle != null && typeof cancelIdleCallback === 'function') {
          cancelIdleCallback(this._initIdle);
          this._initIdle = null;
        }
        if (this._initTimer != null) {
          clearTimeout(this._initTimer);
          this._initTimer = null;
        }

        if (this._surface) {
          this._surface.removeEventListener('touchstart', this._onTouch);
          this._surface.removeEventListener('click', this._onSurfaceClick);
        }
        clearTimeout(this._hideTimer);
        this.classList.remove('hf-video-controls--visible');

        if (this._video) {
          this._video.removeEventListener('playing', this._onVideoPlaying);
          this._video.removeEventListener('pause', this._onVideoPause);
          this._video.removeEventListener('ended', this._onVideoEnded);
          if (!this._video.paused) this._video.pause();
        }
        this._abortPlayback();
        this._playing = false;
        this._visible = false;
        this._initialized = false;
        this._bound = false;
        this._activated = false;
        this._prewarmed = false;

        if (this._observer) {
          this._observer.disconnect();
          this._observer = null;
        }
        if (this._slideObserver) {
          this._slideObserver.disconnect();
          this._slideObserver = null;
        }
        if (this._mountObserver) {
          this._mountObserver.disconnect();
          this._mountObserver = null;
        }
        if (this._iframe) {
          window.removeEventListener('message', this._onMessage);
        }
      }

      _setupObservers() {
        if (this._tryBindSlide()) return;

        const list = this.closest('.hf-carousel__list');
        if (list) {
          this._mountObserver = new MutationObserver(() => {
            if (this._tryBindSlide()) {
              this._mountObserver.disconnect();
              this._mountObserver = null;
            }
          });
          this._mountObserver.observe(list, {
            attributes: true,
            attributeFilter: ['class'],
            subtree: true,
            childList: true,
          });
          return;
        }

        this._setupIntersectionObserver();
      }

      _tryBindSlide() {
        const slide = this.closest('.hf-carousel__slide');
        if (!slide) return false;
        if (!slide.closest('.hf-carousel__list')) return false;
        this._slide = slide;
        this._inSlider = true;
        this._isClone = slide.classList.contains('hf-carousel__slide--clone');
        if (this._isClone) {
          if (this._video) {
            this._video.querySelectorAll('source').forEach((s) => {
              s.removeAttribute('src');
              s.removeAttribute('data-src');
            });
            this._video.removeAttribute('src');
          }
          if (this._iframe) {
            this._iframe.removeAttribute('src');
            this._iframe.removeAttribute('data-src');
          }
          return true;
        }
        this._setupSlideObserver();
        return true;
      }

      _setupIntersectionObserver() {
        this._observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const wasVisible = this._visible;
              this._visible = entry.isIntersecting;
              if (entry.isIntersecting && !wasVisible) this._onVisible();
              else if (!entry.isIntersecting && wasVisible) this._onHidden();
            });
          },
          { threshold: 0, rootMargin: '300px 0px' }
        );
        this._observer.observe(this);
      }

      _pickBestSource(sources) {
        if (!sources.length) return null;
        if (sources.length === 1) return sources[0];
        const probe = document.createElement('video');
        const supportsHLS = !!(probe.canPlayType('application/vnd.apple.mpegurl') || probe.canPlayType('application/x-mpegURL'));
        if (supportsHLS) {
          const hls = sources.find((s) => s.dataset.format === 'm3u8');
          if (hls) return hls;
        }
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const isTablet = !isMobile && window.matchMedia('(max-width: 989px)').matches;
        const targetHeight = isMobile ? 720 : (isTablet ? 1080 : 1440);
        const ranked = sources
          .filter((s) => s.dataset.format !== 'm3u8')
          .map((s) => ({ s: s, h: parseInt(s.dataset.height, 10) || 0 }))
          .sort((a, b) => a.h - b.h);
        if (!ranked.length) return sources[0];
        let chosen = null;
        for (let i = 0; i < ranked.length; i++) {
          if (ranked[i].h >= targetHeight) { chosen = ranked[i].s; break; }
        }
        if (!chosen) chosen = ranked[ranked.length - 1].s;
        return chosen;
      }

      _activateSync(activeMode) {
        if (this._activated || this._isClone) return;
        this._activated = true;
        if (this._video) {
          const sources = Array.from(this._video.querySelectorAll('source[data-src]'));
          const chosen = this._pickBestSource(sources);
          let touched = false;
          sources.forEach((s) => {
            if (s === chosen) {
              s.src = s.dataset.src;
              s.removeAttribute('data-src');
              touched = true;
            } else {
              s.removeAttribute('data-src');
            }
          });
          if (touched) {
            this._video.preload = activeMode ? 'auto' : 'metadata';
            try { this._video.load(); } catch (_) {}
          }
        }
        if (this._iframe && this._iframe.dataset.src) {
          this._iframe.src = this._iframe.dataset.src;
          this._iframe.removeAttribute('data-src');
        }
      }

      _activate(signal) {
        if (this._isClone || this._activated) return Promise.resolve();
        const isActive = this._slide && this._slide.classList.contains('is-active');
        if (isActive || document.readyState === 'complete') {
          this._activateSync(isActive);
          return Promise.resolve();
        }
        return new Promise((resolve) => {
          let cancelled = false;
          const onAbort = () => { cancelled = true; resolve(); };
          const finish = () => {
            if (cancelled) return;
            if (signal) signal.removeEventListener('abort', onAbort);
            this._activateSync(false);
            resolve();
          };
          if (typeof requestIdleCallback === 'function') {
            const id = requestIdleCallback(finish, { timeout: 150 });
            if (signal) signal.addEventListener('abort', () => { try { cancelIdleCallback(id); } catch (_) {} onAbort(); }, { once: true });
          } else {
            const t = setTimeout(finish, 0);
            if (signal) signal.addEventListener('abort', () => { clearTimeout(t); onAbort(); }, { once: true });
          }
        });
      }

      _setupSlideObserver() {
        const isActive = this._slide.classList.contains('is-active');
        this._visible = isActive;
        if (isActive) this._onVisible();

        this._slideObserver = new MutationObserver(() => {
          const active = this._slide.classList.contains('is-active');
          if (active && !this._visible) {
            this._visible = true;
            this._onVisible();
          } else if (!active && this._visible) {
            this._visible = false;
            this._onHidden();
          }
        });
        this._slideObserver.observe(this._slide, { attributes: true, attributeFilter: ['class'] });
      }

      _onVisible() {
        if (this._autoplay) this._play();
        this._prewarmAdjacent();
      }

      _prewarmAdjacent() {
        if (!this._slide) return;
        const siblings = [this._slide.previousElementSibling, this._slide.nextElementSibling];
        siblings.forEach((sibling) => {
          if (!sibling) return;
          const ctrl = sibling.querySelector('hf-video-controls');
          if (!ctrl || ctrl._isClone) return;
          if (ctrl._prewarmed) return;
          ctrl._prewarmed = true;
          if (typeof ctrl._activate !== 'function') return;
          ctrl._activate(null).then(() => {
            if (ctrl._video) {
              ctrl._video.preload = 'auto';
              try { ctrl._video.load(); } catch (_) {}
            }
          });
        });
      }

      _onHidden() {
        if (this._playing) {
          this._pause();
          this._setPlaying(false);
        }
      }

      _resumeIfShouldPlay() {
        if (!this._autoplay) return;
        if (this._isClone) return;
        if (!this.isConnected) return;
        if (!this._video) return;
        let shouldPlay = this._visible;
        if (this._slide) {
          shouldPlay = this._slide.classList.contains('is-active');
        }
        if (shouldPlay && this._video.paused) {
          this._play();
        }
      }

      _togglePlay() {
        this._restartHideTimer();
        if (this._playing) this._pause();
        else this._play();
      }

      _abortPlayback() {
        if (this._playbackCtrl) {
          this._playbackCtrl.abort();
          this._playbackCtrl = null;
        }
      }

      _stillTargetSlide() {
        if (!this._inSlider) return true;
        if (!this._slide) return !!this._visible;
        return this._slide.classList.contains('is-active');
      }

      _waitReadyToPlay(v, signal) {
        if (v.readyState >= 2) return Promise.resolve();
        return new Promise((resolve) => {
          let done = false;
          const finish = () => {
            if (done) return;
            done = true;
            v.removeEventListener('canplay', finish);
            v.removeEventListener('loadedmetadata', finish);
            if (signal) signal.removeEventListener('abort', finish);
            resolve();
          };
          v.addEventListener('canplay', finish);
          v.addEventListener('loadedmetadata', finish);
          if (signal) signal.addEventListener('abort', finish, { once: true });
        });
      }

      _attemptPlay(v, signal) {
        return v.play().catch(() => {
          if (signal.aborted) return;
          return new Promise((resolve) => {
            const onAbort = () => { clearTimeout(t); resolve(); };
            const t = setTimeout(() => {
              signal.removeEventListener('abort', onAbort);
              if (signal.aborted || !v.isConnected || !v.paused || !this._stillTargetSlide()) {
                resolve();
                return;
              }
              v.muted = true;
              v.play().catch(() => {}).then(resolve, resolve);
            }, 200);
            signal.addEventListener('abort', onAbort, { once: true });
          });
        });
      }

      _play() {
        this._abortPlayback();
        const controller = new AbortController();
        this._playbackCtrl = controller;
        const signal = controller.signal;

        this._activate(signal).then(() => {
          if (signal.aborted || !this._stillTargetSlide()) return;
          if (this._iframe) {
            this._postIframeCommand('play');
            this._setPlaying(true);
            return;
          }
          if (!this._video || !this._video.isConnected) return;
          const v = this._video;
          v.preload = 'auto';
          v.muted = this._muted;
          return this._waitReadyToPlay(v, signal).then(() => {
            if (signal.aborted || !this._stillTargetSlide() || !v.isConnected) return;
            return this._attemptPlay(v, signal);
          });
        }).catch(() => {});
      }

      _pause() {
        this._abortPlayback();
        if (this._video) {
          this._video.pause();
        } else if (this._iframe) {
          this._postIframeCommand('pause');
          this._setPlaying(false);
        }
      }

      _setPlaying(state) {
        this._playing = state;
        this.dataset.playing = String(state);
      }

      _toggleMute() {
        this._restartHideTimer();
        this._muted = !this._muted;
        this.dataset.muted = String(this._muted);

        if (this._video) {
          this._video.muted = this._muted;
        } else if (this._iframe) {
          this._postIframeCommand(this._muted ? 'mute' : 'unmute');
        }
      }

      _handleTouch(e) {
        if (e.target.closest('.hf-video-controls__btn')) return;
        this.classList.add('hf-video-controls--visible');
        this._restartHideTimer();
      }

      _handleSurfaceClick(e) {
        if (e.target.closest('.hf-video-controls__btn')) return;
        this._togglePlay();
      }

      _restartHideTimer() {
        clearTimeout(this._hideTimer);
        this._hideTimer = setTimeout(() => {
          this.classList.remove('hf-video-controls--visible');
        }, 3000);
      }

      _getVideoType() {
        return this._iframe && this._iframe.dataset.videoType || null;
      }

      _postIframeCommand(action) {
        if (!this._iframe || !this._iframe.contentWindow) return;

        const type = this._getVideoType();

        if (type === 'youtube') {
          const cmdMap = { play: 'playVideo', pause: 'pauseVideo', mute: 'mute', unmute: 'unMute' };
          const func = cmdMap[action];
          if (func) {
            this._iframe.contentWindow.postMessage(
              JSON.stringify({ event: 'command', func: func, args: '' }), '*'
            );
          }
        } else if (type === 'vimeo') {
          const cmdMap = { play: 'play', pause: 'pause', mute: 'setVolume', unmute: 'setVolume' };
          const method = cmdMap[action];
          if (method) {
            const msg = { method: method };
            if (action === 'mute') msg.value = 0;
            if (action === 'unmute') msg.value = 1;
            this._iframe.contentWindow.postMessage(JSON.stringify(msg), '*');
          }
        }
      }

      _handleIframeMessage(event) {
        try {
          const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;

          if (data.event === 'onReady' || (data.info && data.info.playerState !== undefined)) {
            if (this._autoplay && this._visible && !this._playing) this._play();
          }

          if (data.info && data.info.playerState === 1) this._setPlaying(true);
          else if (data.info && data.info.playerState === 2) this._setPlaying(false);
        } catch (_) {}
      }
    }

    customElements.define('hf-video-controls', HfVideoControls);

    if (!window.__hfVideoModalWatcher) {
      window.__hfVideoModalWatcher = true;
      var prevOpen = false;
      try { prevOpen = !!document.body && document.body.classList.contains('overflow-hidden'); } catch (e) {}
      var checkAndRestore = function () {
        var curr = false;
        try { curr = !!document.body && document.body.classList.contains('overflow-hidden'); } catch (e) {}
        if (prevOpen && !curr) {
          setTimeout(function () {
            try {
              document.querySelectorAll('hf-video-controls').forEach(function (el) {
                if (el && typeof el._resumeIfShouldPlay === 'function') {
                  el._resumeIfShouldPlay();
                }
              });
            } catch (e) {}
          }, 80);
        }
        prevOpen = curr;
      };
      if (typeof MutationObserver !== 'undefined' && document.body) {
        new MutationObserver(checkAndRestore).observe(document.body, { attributes: true, attributeFilter: ['class'] });
      }
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["render-video-card-block"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hf-autoplay-video')) {
    class HfAutoplayVideo extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        var run = this._init.bind(this);
        if (typeof requestIdleCallback === 'function') {
          this._idle = requestIdleCallback(run, { timeout: 1500 });
        } else {
          this._timer = setTimeout(run, 0);
        }
      }

      disconnectedCallback() {
        if (this._idle != null && typeof cancelIdleCallback === 'function') {
          cancelIdleCallback(this._idle);
          this._idle = null;
        }
        if (this._timer != null) {
          clearTimeout(this._timer);
          this._timer = null;
        }
        if (this._observer) {
          this._observer.disconnect();
          this._observer = null;
        }
        this._pause();
      }

      _init() {
        this._idle = null;
        this._timer = null;
        if (!this.isConnected || this._initialized) return;
        this._initialized = true;

        var videos = Array.prototype.slice.call(this.querySelectorAll('video'));
        if (!videos.length) return;

        var activeVariant = window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop';
        var active = videos[0];
        var inactive = [];

        if (videos.length > 1) {
          active = null;
          videos.forEach(function (v) {
            var container = v.closest('[data-video-variant]');
            if (container && container.dataset.videoVariant === activeVariant) active = v;
            else inactive.push(v);
          });
          if (!active) {
            active = videos[0];
            inactive = videos.slice(1);
          }
        }

        inactive.forEach(function (v) {
          v.querySelectorAll('source').forEach(function (s) {
            s.removeAttribute('src');
            s.removeAttribute('data-src');
          });
          v.removeAttribute('src');
          try { v.pause(); } catch (e) {}
          try { v.load(); } catch (e) {}
        });

        this._video = active;
        this._video.muted = true;
        this._video.loop = true;
        this._video.playsInline = true;
        this._activated = false;

        this._observer = new IntersectionObserver(this._onIntersect.bind(this), {
          threshold: 0,
          rootMargin: '300px 0px'
        });
        this._observer.observe(this);
      }

      _onIntersect(entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) this._activateAndPlay();
          else this._pause();
        }
      }

      _pickSource(sources) {
        if (!sources.length) return null;
        if (sources.length === 1) return sources[0];
        var isMobile = window.matchMedia('(max-width: 749px)').matches;
        var isTablet = !isMobile && window.matchMedia('(max-width: 989px)').matches;
        var target = isMobile ? 720 : (isTablet ? 1080 : 1440);
        var ranked = sources
          .map(function (s) { return { s: s, h: parseInt(s.dataset.height, 10) || 0 }; })
          .sort(function (a, b) { return a.h - b.h; });
        var chosen = null;
        for (var i = 0; i < ranked.length; i++) {
          if (ranked[i].h >= target) { chosen = ranked[i].s; break; }
        }
        if (!chosen) chosen = ranked[ranked.length - 1].s;
        return chosen;
      }

      _activateAndPlay() {
        var v = this._video;
        if (!v) return;
        if (!this._activated) {
          this._activated = true;
          var sources = Array.prototype.slice.call(v.querySelectorAll('source[data-src]'));
          var chosen = this._pickSource(sources);
          sources.forEach(function (s) {
            if (s === chosen) {
              s.src = s.dataset.src;
              s.removeAttribute('data-src');
            } else {
              s.removeAttribute('data-src');
            }
          });
          v.preload = 'auto';
          try { v.load(); } catch (e) {}
        }
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }

      _pause() {
        if (this._video && !this._video.paused) {
          try { this._video.pause(); } catch (e) {}
        }
      }
    }

    customElements.define('hf-autoplay-video', HfAutoplayVideo);
  }
  } catch(e) { console.error(e); }
})();

})();
